import { render, staticRenderFns } from "./inActiveDoctors.vue?vue&type=template&id=673b8cb8&scoped=true"
import script from "./inActiveDoctors.vue?vue&type=script&lang=js"
export * from "./inActiveDoctors.vue?vue&type=script&lang=js"
import style0 from "./inActiveDoctors.vue?vue&type=style&index=0&id=673b8cb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b8cb8",
  null
  
)

export default component.exports